import {LOCAL_STORAGE_KEYS} from "common/constants/localStorageKeys";
import {redirectToLogin} from "helpers";
import React, {PureComponent} from "react";
import {Spinner} from "react-bootstrap";
import {RouteComponentProps} from "react-router-dom";
import AuthenticationService from "services/authentication.service";
import authenticationService from "services/authentication.service";
import {AuthenticationContext} from "services/context/authentication.context";

interface AsCustomerLoaderState {
  loading: boolean;
}

export default class AsCustomerLoader extends PureComponent<RouteComponentProps, AsCustomerLoaderState> {

  static contextType = AuthenticationContext;
  constructor(props: RouteComponentProps) {
      super(props);

      this.state = {
          loading: true,
      };
  }

  getCustomerFromParams = () => {
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const customerIdParam = url.searchParams.get("id");

    if(url.searchParams.has("id")){
      urlParams.delete("id");
    }

    window.history.replaceState({}, document.title, url.toString());

    const customerId = Number(customerIdParam);

    if (!customerIdParam || isNaN(customerId)) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID);

      this.context.dispatch({
        type: "setCustomerId",
        value: null
      });

      return;
    }

    this.context.dispatch({
      type: "setCustomerId",
      value: customerId
    });

    localStorage.setItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID, customerIdParam);
};

  initializeAuth = async () => {
    const url = new URL(window.location.href);
    const tokenParam = url.searchParams.get("token");

    if (tokenParam) {
      try {
        await authenticationService.exchangeToken(tokenParam);
      } catch (e) {
        console.error(e)
      }
    }

    await AuthenticationService.refresh();

    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTHORIZATION_HEADER);
    const userId = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_ID);

    if(!token && !userId){
      redirectToLogin();
      return
    }

    this.getCustomerFromParams();

    this.context.dispatch({
      type: "setToken",
      value: token
    });

    this.context.dispatch({
        type: "setAuthenticated",
        value: true
    });

    this.context.dispatch({
        type: "setUserId",
        value: userId
    });

    this.props.history.replace('/esileht')
  }

  componentDidMount(): void {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTHORIZATION_HEADER);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ID);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
    this.context.dispatch({
        type: "setUserId",
        value: null
    });
    setTimeout(() => {
      this.initializeAuth()
    }, 50);
  }

  render() {
      return (
              <div className="d-flex">
                  {
                      this.state.loading &&
                      <div className="m-auto">
                          <Spinner animation={"grow"}/>
                      </div>
                  }
              </div>
      );
  }
}
